import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

//Import Icons
import { useRole } from "components/Hooks/UserHooks";
import FeatherIcon from "feather-icons-react";
import { ROLES_FOR_APP, isHavePermissionRole } from "helpers/role";
import { useTranslation } from "react-i18next";
import { ROUTES } from "routes/allRoutes";

const Navdata = () => {
    const history = useNavigate();
    const { t } = useTranslation();
    const { userPermissions } = useRole();

    const [menuActive, setMenuActive] = useState<string>('DASHBOARD');

    // Multi Level
    const [isLevel1, setIsLevel1] = useState<boolean>(false);

    const [isCurrentState, setIsCurrentState] = useState('Dashboard');

    function updateIconSidebar(e: any) {
        if (e && e.target && e.target.getAttribute("sub-items")) {
            const ul: any = document.getElementById("two-column-menu");
            const iconItems = ul.querySelectorAll(".nav-icon.active");
            let activeIconItems = [...iconItems];
            activeIconItems.forEach((item) => {
                item.classList.remove("active");
                var id = item.getAttribute("sub-items");
                const getID = document.getElementById(id) as HTMLElement
                if (getID)
                    getID.classList.remove("show");
            });
        }
    }

    useEffect(() => {
        document.body.classList.remove('twocolumn-panel');
    }, [history]);

    const menuItems: any = [
        // {
        //     id: "dashboard",
        //     label: t('Dashboards'),
        //     icon: <FeatherIcon icon="home" className="icon-dual" />,
        //     link: ROUTES.DASHBOARD,
        //     click: function (e: any) {
        //         setMenuActive((prev) => 'DASHBOARD');
        //         setIsCurrentState((prev) => 'Dashboard');
        //         updateIconSidebar(e);
        //     },
        //     stateVariables: (menuActive === 'DASHBOARD'),
        //     isShow: isHavePermissionRole(ROLES_FOR_APP.DASHBOARD_VIEW, userPermissions),
        //     // subItems: []
        // },
        {
            id: "multilevel12",
            label: t("Posts"),
            icon: <i className="ri-newspaper-line" />,
            link: ROUTES.POSTS,
            click: function (e: any) {
                setMenuActive((prev) => "POSTS");
                setIsCurrentState((prev) => "Posts");
                updateIconSidebar(e);
            },
            stateVariables: menuActive === "POSTS",
            isShow: isHavePermissionRole([ROLES_FOR_APP.POSTS], userPermissions),
        },
        {
            id: "multilevel12",
            label: t("Comments/Replies"),
            icon: <i className="bx bx-message-square-dots" />,
            link: ROUTES.COMMENTS_REPLIES,
            click: function (e: any) {
                setMenuActive((prev) => "COMMENTS_REPLIES");
                setIsCurrentState((prev) => "Comments/Replies");
                updateIconSidebar(e);
            },
            stateVariables: menuActive === "COMMENTS_REPLIES",
            isShow: isHavePermissionRole([ROLES_FOR_APP.COMMENTS_REPLIES], userPermissions),
        },
        {
            id: "multilevel12",
            label: t("Configuration"),
            icon: <i className="ri-settings-3-line" />,
            link: ROUTES.CONFIGURATION,
            click: function (e: any) {
                setMenuActive((prev) => "CONFIGURATION");
                setIsCurrentState((prev) => "Configuration");
                updateIconSidebar(e);
            },
            stateVariables: menuActive === "CONFIGURATION",
            isShow: isHavePermissionRole([ROLES_FOR_APP.CONFIGURATION], userPermissions),
        },


    ];
    return <React.Fragment>{menuItems}</React.Fragment>;
};
export default Navdata;
